<mat-dialog-content>
  <form [formGroup]="form">
    <div class="flex flex-col">
      <div class="flex flex-row max-sm:flex-col gap-[0.5em]">
        <div style="width: 10px"></div>
        <div>
          <mat-form-field style="width: 120px">
            <mat-label>Length</mat-label>
            <input matInput formControlName="length">
          </mat-form-field>
          <app-unit-select
            formControlName="lengthUnitId"
            [validUnitIds]="validLengthUnitIds"
            class="unit-selector"
            required
          ></app-unit-select>
        </div>
        <div class="flex flex-col">
          <div class="grow basis-[30%] max-h-[30%]"></div>
          <fa-icon [icon]="faMultiply"></fa-icon>
        </div>
        <div>
          <mat-form-field style="width: 120px">
            <mat-label>Width</mat-label>
            <input matInput formControlName="width">
          </mat-form-field>
          <app-unit-select
            formControlName="widthUnitId"
            [validUnitIds]="validLengthUnitIds"
            class="unit-selector"
            required
          ></app-unit-select>
        </div>
        <div class="flex flex-col">
          <div class="grow basis-[30%] max-h-[30%]"></div>
          <fa-icon [icon]="faEquals"></fa-icon>
        </div>
        <div class="flex flex-row">
          <mat-form-field style="width: 120px">
            <mat-label>Area</mat-label>
            <input matInput formControlName="area">
          </mat-form-field>
          <app-unit-select
            formControlName="areaUnitId"
            [validUnitIds]="validAreaUnitIds"
            class="unit-selector"
            required
          ></app-unit-select>
          <div>
          </div>
        </div>

      </div>
      <div class="flex flex-row max-sm:flex-col gap-[0.5em]">
        <div class="flex flex-col">
          <div class="grow basis-[30%] max-h-[30%]"></div>
          <fa-icon [icon]="faMultiply"></fa-icon>
        </div>
        <div>
          <mat-form-field style="width: 120px">
            <mat-label>Thickness</mat-label>
            <input matInput formControlName="height">
          </mat-form-field>
          <app-unit-select
            formControlName="heightUnitId"
            [validUnitIds]="validLengthUnitIds"
            class="unit-selector"
            required
          ></app-unit-select>
        </div>
      </div>

      <mat-divider></mat-divider>
      <div class="flex flex-row max-sm:flex-col gap-[0.5em]" style="margin-top: 10px">
        <div class="flex flex-col">
          <div class="grow basis-[30%] max-h-[30%]"></div>
          <fa-icon [icon]="faEquals"></fa-icon>
        </div>
        <div>
          <mat-form-field style="width: 120px">
            <mat-label>Volume</mat-label>
            <input matInput formControlName="volume">
          </mat-form-field>
          <app-unit-select
            formControlName="volumeUnitId"
            [validUnitIds]="validVolumeUnitIds"
            class="unit-selector"
            required
          ></app-unit-select>
        </div>
      </div>
    </div>
  </form>
  <button mat-raised-button (click)="clear()" style="margin-bottom: 0.5em">Clear Values</button>
</mat-dialog-content>
